import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { create, updateData } from '../../Chart/DistributionChart/chart';

const MentalHealth = ({ healthReportData }) => {
  useEffect(() => {
    const dexterityList = values(healthReportData.mental_health);
    dexterityList.map(each => {
      let data = { ...each, section: 'mental_health', chartVal: each.value };
      var settings = {
        el: each.display_label.replace(/ /g, '_') || 'none',
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      };
      create(settings);
      updateData(data);
    });
  }, []);
  return (
    <Element>
      {get(healthReportData, 'mental_health.depression_severity.value') ===
        null ? (
        <NoData />
      ) : (
        <Element>
          <Element marginTop="30px">
            <Text family="GTAR" size="14px" color="#959595">
              Patient Health Questionnaire (PHQ-9)
            </Text>
          </Element>
          <Element>
            <Text family="GTAM" size="14px" color="#222222">
              Mental health is assessed by the PHQ-9, a well-validated survey
              used to predict the presence and severity of depression.
            </Text>
          </Element>
          <Element marginTop="60px">
            <Text family="GTAR" size="12px" color="#959595">
              Interpretation
            </Text>
          </Element>
          <Element>
            <Text family="GTAM" size="32px" color="#222222">
              {get(
                healthReportData,
                'mental_health.depression_severity.interpretation'
              )}
            </Text>
          </Element>
          <div
            id={
              get(
                healthReportData,
                'mental_health.depression_severity.display_label'
              ).replace(/ /g, '_') || 'none'
            }
            style={{ width: '227px', marginTop: '20px', marginLeft: '5px' }}
          ></div>
        </Element>
      )}
    </Element>
  );
};

export default MentalHealth;
